import React, { useEffect, useState } from 'react'
import { Switch, Popconfirm, Button } from "components/common";
import { UserInfoSmallScreenWrapper } from "./UserDetails.styled";
import { getUserPermissions } from "utils/text";
import { callGetApiWithAuth, callPostApi, callPutApi } from "utils/api";
import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import { SuccessNotification } from "components/common";
import {
    Row,
    Col,
    Select_,
    Input,
    message,
    Tag,
    Checkbox,
    Empty,
} from "components/common";

const UserInfoSm = ({
    id,
    data,
    accessLevel,
    location,
    setGetUser,
    getUserDetail,
    isSmallScreen
}) => {
    const [repCom, setRepCom] = useState([]);
    const [postSetterCom, setpostSetterCom] = useState("");
    const [postRepCom, setpostRepCom] = useState("");
    const [postLocation, setPostLocation] = useState("");
    const [postAccessLevel, setPostAccessLevel] = useState("");
    const [isActive, setIsActive] = useState();
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [sitPayAmount, setSitPayAmount] = useState("");
    const [kwPay, setKwPay] = useState("");
    const [overRide, setOverRide] = useState("");
    const [redline, setRedline] = useState("");
    const [isResetLoading, setIsResetLoading] = useState(false);
    const [check, setCheck] = useState(data?.companyCommission);
    const [availabilty, setAvailabilty] = useState(data?.available);
    const [companyAmount, setCompanyAmount] = useState("");
    const [showDisable, setShowDisable] = useState(!data?.companyCommission);
    const [perSit, setPerSitAmount] = useState("");
    const [isReferrals, setIsReferrer] = useState([]);

    let ReferralsCount = isReferrals?.length;

    let values = accessLevel?.filter((el) => String(el?._id) === data?.roleId)[0]
        ?.role;
    console.log(values, accessLevel, data);
    let locationText = location?.filter((el) => el?.id == data?.locationId)?.[0];

    const UserUpdateHandler = (changes) => {
        callPutApi(`/user/${id}`, changes, (data) => {
            SuccessNotification("Data Successfully Updated");
            setIsDeleteLoading(false);
            getUserDetail();
            console.log(data)
        }, (err) => { setIsDeleteLoading(false); })
    }
    const changeCheckStatus = (e) => {
        setCheck(e.target.checked);
        setShowDisable(check);
    };

    const postResetPassword = () => {
        setIsResetLoading(true);
        callPostApi(
            `/auth/reset-password/${id}`,
            null,
            (data) => {
                SuccessNotification("Password Reset Link sent");
                setIsResetLoading(false);
            },
            (err) => {
                console.log(err);
                setIsResetLoading(false);
            }
        );
    };
    const postAccessApi = (e) => {
        setPostAccessLevel(e.target.value);
        let formData = {
            roleId: e.target.value,
        };
        UserUpdateHandler(formData)
    };
    const postActiveApi = () => {
        setIsDeleteLoading(true);

        setIsActive(!isActive);
        let formData = {
            active: !isActive,
        };
        UserUpdateHandler(formData)
    };
    const postLocationApi = (e) => {
        setPostLocation(e.target.value);
        let formData = {
            locationId: e.target.value,
        };
        UserUpdateHandler(formData)
    };
    const postEditKwApi = () => {
        let formData = {
            method: "kwPay",
            kwPay: kwPay,
        };
        UserUpdateHandler(formData)
    };
    const postEditSitApi = () => {
        let formData = {
            method: "sitPayAmount",
            sitPayAmount: sitPayAmount,
        };
        UserUpdateHandler(formData)
    };


    const postEditPerSitApi = () => {
        let formData = {
            method: "perSit",
            perSit: perSit,
        };
        UserUpdateHandler(formData)
    };

    const postOverrideApi = () => {
        let formData = {
            method: "overRide",
            overRide: overRide,
        };
        UserUpdateHandler(formData)
    };

    const postSetterApi = (e) => {
        setpostSetterCom(e);
        let formData = {
            method: "postSetterCom",
            postSetterCom: postSetterCom,
        };
        UserUpdateHandler(formData)
    };

    const postRepApi = (e) => {
        setpostRepCom(e);
        let formData = {
            method: "postRepCom",
            postRepCom: postRepCom,
        };
        UserUpdateHandler(formData)
    };

    const postPerSitAmount = () => {
        let formData = {
            method: "perSitAmount",
            perSitAmount: perSit,
        };
        UserUpdateHandler(formData)
    };
    const postEditRedLineApi = () => {
        let formData = {
            method: "redline",
            redline: redline
        };
        UserUpdateHandler(formData)
    };
    const handleAvailiblityChange = () => {
        setAvailabilty(!availabilty)
        let formData = {
            available: !availabilty
        };
        UserUpdateHandler(formData)
    };
    const RepComTiers = () => {
        callGetApiWithAuth(
            "/repcommission",
            (data) => {
                setRepCom(data);
            },
            (err) => { }
        );
    };
    const postCompanyCheckApi = () => {
        let formData = {
            companyCommission: check,
        };
        UserUpdateHandler(formData)
    };
    const postCompanyAmountApi = () => {
        let formData = {
            companyKW: companyAmount,
        };
        UserUpdateHandler(formData)
    };

    useEffect(() => {
        RepComTiers();
    }, []);
    useEffect(() => {
        if (data) {
            setPostLocation(data?.locationId);
            setpostSetterCom(data?.repWithSetterCommissionTier);
            setpostRepCom(data?.repCloserCommissionTier);
            setPostAccessLevel(data?.roleId);
            setIsActive(data?.active);
            setSitPayAmount(data?.sitPayAmount);
            setKwPay(data?.kwPay);
            setRedline(data?.redline);
            setOverRide(data?.override);
            setShowDisable(!data?.companyCommission);
            setCheck(data?.companyCommission);
            setCompanyAmount(data?.companyKW);
            setPerSitAmount(data?.perSitAmount);
            setIsReferrer(data?.referrals);
        }
    }, [
        data?.locationId,
        data?.accessLevel,
        data?.companyCommission,
        ReferralsCount,
    ]);

    return (
        <UserInfoSmallScreenWrapper>

            <div className="info-container">
                <div className="title">Email:</div>
                <div className="content">{data?.email}</div>
            </div>
            <div className="info-container">
                <div className="title">Access Level:</div>
                <div className="content">
                    {getUserPermissions('edit-user-access-level-action') ? (
                        <div className="select">
                            <select value={postAccessLevel} onChange={postAccessApi}>
                                {accessLevel.map((e) => (
                                    <option value={e._id}>{e.role}</option>
                                ))}
                            </select>
                        </div>
                    ) : (
                        accessLevel?.filter((el) => el?.id == data?.accessLevel)[0]?.role
                    )}
                </div>
            </div>
            <div className="info-container">
                <div className='title'>Location:</div>
                <div className='content'>
                    {getUserPermissions("edit-user-location-action") ? (
                        <div className="select">
                            <select value={postLocation} onChange={postLocationApi}>
                                {location.map((e) => (
                                    <option value={e._id}>{e.name}, {e.state}</option>
                                ))}
                            </select>
                        </div>
                    ) : (
                        <div>
                            {locationText?.name}, {locationText?.state}
                        </div>
                    )}
                </div>
            </div>
            <div className="info-container">
                <div className='title'>Availability:</div>
                <div className='content'>
                    <Switch
                        checked={availabilty}
                        checkedChildren="Yes"
                        unCheckedChildren="No"
                        onChange={handleAvailiblityChange}
                    />
                </div>
            </div>
            <div className="info-container setter-info-container " >
                <div className="title">Company KW:</div> {/* Added "title" class */}
                <div className="user-text"> {/* Added "user-text" class */}
                    <Input
                        value={companyAmount}
                        onChange={(e) => setCompanyAmount(e.target.value)}
                    />
                    <a>
                        <CloseCircleFilled className="edit-cross-tick" />{' '}
                    </a>
                    <a>
                        <CheckCircleFilled
                            onClick={postEditKwApi}
                            className="edit-cross-tick"
                        />{' '}
                    </a>
                </div>
            </div>
            {values === 'Setter' ? (
                <>
                    <div className="info-container setter-info-container "> {/* Added "setter-info-container" class */}
                        <div className="title">Sit Pay Amount:</div>
                        <div className="content">
                            {/* Add your desired styling for the content here */}
                        </div>
                        {getUserPermissions('edit-sit-pay-amount-action') && (
                            <div className="select">
                                <div className="user-text">
                                    <Input
                                        value={sitPayAmount}
                                        onChange={(e) => setSitPayAmount(e.target.value)}
                                    />
                                    <a>
                                        <CloseCircleFilled className="edit-cross-tick" />{' '}
                                    </a>
                                    <a>
                                        <CheckCircleFilled
                                            onClick={postEditSitApi}
                                            className="edit-cross-tick"
                                        />{' '}
                                    </a>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="info-container setter-info-container"> {/* Added "setter-info-container" class */}
                        <div className="col-container">
                            <div className="title">KW Pay:</div>
                        </div>
                        {getUserPermissions('edit-user-kw-pay-action') && (
                            <div className="col-container">
                                <div className="user-text">
                                    <Input
                                        value={kwPay}
                                        onChange={(e) => setKwPay(e.target.value)}
                                    />
                                    <a>
                                        <CloseCircleFilled className="edit-cross-tick" />{' '}
                                    </a>
                                    <a>
                                        <CheckCircleFilled
                                            onClick={postEditKwApi}
                                            className="edit-cross-tick"
                                        />{' '}
                                    </a>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            ) : null}
            {values === 'Manager' ? (
                <>
                    <div className="info-container setter-info-container "> {/* Added "setter-info-container" class */}
                        <div className="title">Manager Override:</div>
                        <div className="content">
                            {/* Add your desired styling for the content here */}
                        </div>
                        <div className="user-text"> {/* Added "user-text" class */}
                            <Input
                                value={overRide}
                                onChange={(e) => setOverRide(e.target.value)}
                            />
                            <a>
                                <CloseCircleFilled className="edit-cross-tick" />{' '}
                            </a>
                            <a>
                                <CheckCircleFilled
                                    onClick={postOverrideApi}
                                    className="edit-cross-tick"
                                />{' '}
                            </a>
                        </div>
                    </div>
                </>
            ) : null}
            {values !== "Setter" ? (
                <>
                    <div className="info-container">
                        <div className="title">Setter Commission Tier:</div>
                        <div className="content">
                            {getUserPermissions('edit-user-redline-action') ? (
                                <div className="select">
                                    <select value={postSetterCom} onChange={postSetterApi}>
                                        {repCom.map((e) => (
                                            <option key={e._id} value={e._id}>{e.name}</option>
                                        ))}
                                    </select>
                                </div>
                            ) : (
                                repCom?.find((el) => String(el?._id) == data?.repCom)?.name
                            )}
                        </div>
                    </div>
                    <div className="info-container">
                        <div className="title">Closer Commission Tier:</div>
                        <div className="content">
                            {getUserPermissions('edit-user-redline-action') ? (
                                <div className="select">
                                    <select value={postRepCom} onChange={postRepApi}>
                                        {repCom.map((e) => (
                                            <option key={e._id} value={e._id}>{e.name}</option>
                                        ))}
                                    </select>
                                </div>
                            ) : (
                                repCom?.find((el) => String(el?._id) == data?.repCom)?.name
                            )}
                        </div>
                    </div>
                </>
            ) : null}
            {values === 'Setter Manager' ? (
                <>
                    <div className="info-container setter-info-container"> {/* Added "setter-info-container" class */}
                        <div className="title">Per Sit Amount:</div> {/* Added "title" class */}

                        <div className="user-text"> {/* Added "user-text" class */}
                            <Input
                                value={perSit}
                                onChange={(e) => setPerSitAmount(e.target.value)}
                            />
                            <a>
                                <CloseCircleFilled className="edit-cross-tick" />{' '}
                            </a>
                            <a>
                                <CheckCircleFilled
                                    onClick={postEditPerSitApi}
                                    className="edit-cross-tick"
                                />{' '}
                            </a>
                        </div>
                    </div>
                </>
            ) : null}
            <div className="info-container">
                <div className='title'>Activity:</div>
                <div className='content'>
                    <Switch
                        checked={isActive}
                        checkedChildren="Active"
                        unCheckedChildren="InActive"
                        onChange={postActiveApi}
                    />
                </div>
            </div>
            <div className="btn-container">
                {getUserPermissions("user-reset-password-action") && (
                    <Popconfirm
                        title="Are you Sure you want to reset password?"
                        onConfirm={postResetPassword}
                    >
                        <Button
                            loading={isResetLoading}
                            className="reset-btn"
                            title="Reset Password"
                        />
                    </Popconfirm>
                )}
            </div>
        </UserInfoSmallScreenWrapper>

    )
}

export default UserInfoSm